import { Component, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { IonicPage, NavController, NavParams, PopoverController, Events, AlertController, ToastController } from 'ionic-angular';
import { interval } from 'rxjs/observable/interval';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { cloneDeep } from 'lodash';

import { TabsServiceProvider } from '../../providers/tabs-service/tabs-service';
import { StripeServiceProvider } from '../../providers/stripe-service/stripe-service';
import { CoffeService } from '../../interfaces/CoffeService.interface';
import { PaymentChangeMethodPopoverPage } from '../payment-change-method-popover/payment-change-method-popover';
import { BookingServiceProvider } from '../../providers/booking-service/booking-service';
import { PaymentErrorPage } from '../payment-error/payment-error';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';
import { LoyalityPoints } from '../../interfaces/LoyalityPoints.interface';
import { PaymentNewCardPage } from '../payment-new-card/payment-new-card';

@IonicPage()
@Component({
  selector: 'page-coffe-shop-payment',
  templateUrl: 'coffe-shop-payment.html',
})
export class CoffeShopPaymentPage {
  private subscription: Subscription;
  public coffeShop: any = this.coffeShopService.coffeShop;
  public services: CoffeService[] = [];
  private selectedServices: CoffeService[] = [];
  public viewServices: CoffeService[] = [];
  public paymentMethods: any = null;;
  public loyalty: LoyalityPoints = null;

  public selectedDate: string = this.coffeShopService.requestDateFormatter(this.coffeShopService.selectedDate);
  public selectedTime: string = this.coffeShopService.selectedTime;
  public readytime: string = '';
  public buttonMessage: string = '';


  public flipclock: number = 0;
  public totalCost: number = 0;
  public totalRedemptionApplied: number = 0;

  public defaultPaymentMethod = null;
  public customer = null;

  public loading: boolean = false;
  public showRedeemButton: boolean = true;
  public freeBooking: boolean = false;
  public disablePaymentButton: boolean = false;
  public totalAfterRedemptionApplied: any;

  //variables for set booking button message
  private bookedDate: Date;
  private nowMoment: Date;
  public selectedBarber: any = 0;
  public couponCode: any = null;
  public couponDetails: any = null;
  public discount_amount = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public alertCtrl: AlertController,
    private tabsService: TabsServiceProvider,
    private stripeService: StripeServiceProvider,
    private errorHandler: ErrorHandler,
    private bookingService: BookingServiceProvider,
    private popoverCtrl: PopoverController,
    public coffeShopService: CoffeShopService,
    public teastCtrl: ToastController) {
    events.subscribe('stripe:paymentMethodSaved', (paymentMethod) => {
      this.paymentMethods.data.push(paymentMethod);
      this.defaultPaymentMethod = paymentMethod;
      this.customer.invoice_settings.default_payment_method = paymentMethod.id;
    });
  }

  ionViewCanEnter(): void {
    this.loading = true;
    this.tabsService.hide();
    this.subscribeToBookingServiceProviderEvents();
    const promisesArray: Promise<any>[] = [
      this.coffeShopService.getLoyalityPoinst(this.coffeShopService.coffeShop.id).toPromise(),
      null,
      null
    ];
    Promise.all(promisesArray).then(([loyalty, customer, methods]: [any, any, LoyalityPoints]) => {
      loyalty ? this.loyalty = loyalty : null;
      customer ? this.customer = customer : customer;
      this.services = this.navParams.get('services');
      this.selectedBarber = this.navParams.get('selectedBarber') || 0;
      this.selectedServices = cloneDeep(this.coffeShopService.selectedServices);
      this.setTotalCost();
      const bookedDate = new Date(new Date(new Date(new Date(this.coffeShopService.selectedDate).setHours(+this.selectedTime.split(':')[0])).setMinutes(+this.selectedTime.split(':')[1])));
      this.bookedDate = cloneDeep(bookedDate);
      this.nowMoment = this.convertTZ(new Date(), this.coffeShop.timezone.timezone);

      this.setBookingButtonMessage();
      const today = this.convertTZ(new Date(), this.coffeShop.timezone.timezone);
      const millisecounds = new Date(bookedDate).getTime() - today.getTime();
      this.flipclock = parseInt(`${Math.ceil(millisecounds / 1000 / 60)}`);
      if (this.flipclock > 0) {
        this.subscription = interval(60000).subscribe(() => {
          if (this.flipclock > 0) {
            this.flipclock = this.flipclock - 1;
          } else {
            this.subscription.unsubscribe();
          }
        });
      }
      this.readytime = 'ready at ' + moment(bookedDate).format('dddd DD MMMM HH:mm a in');
      this.loading = false;
      methods ? this.paymentMethods = methods : null;
      this.setDefaultSource();
      this.setPaymentButton();
      this.initialViewServices();
    }).catch((error: HttpErrorResponse) => this.errorHandler.handleError(error));
  }
  ionViewCanLeave() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
  private initialViewServices(): void {
    this.viewServices = cloneDeep(this.selectedServices).map((service: CoffeService) => {
      if (service.doppings) {
        const sizeIndex = service.doppings.findIndex((dopping: CoffeService) => dopping.service_type === 1)
        if (sizeIndex >= 0) {
          service.name = `${service.quantity} x ${service.name} (${service.doppings[sizeIndex].size})`;
          service.price += service.doppings[sizeIndex].price;
          service.doppings.splice(sizeIndex, 1);
        } else {
          service.name = `${service.quantity} x ${service.name} (${service.size})`;
        }
        service.doppings = service.doppings.map((dopping: CoffeService) => {
          if (dopping.service_type === 2) {
            const quantity_string = dopping.quantity >= 2 ? `${dopping.quantity} x ` : '';
            dopping.name = `${quantity_string}${dopping.name}${dopping.kind ? ' (' + dopping.kind + ')' : ''}`;
            service.price += dopping.quantity * dopping.price;
          }
          return dopping;
        })
      } else {
        service.name = `${service.quantity} x ${service.name}${service.size ? ' (' + service.size + ')' : ''}`;
      }
      return service;
    });
  }
  private convertTZ(date: string | Date, tzString: string): Date {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
  }
  private setPaymentButton(): void {
    if (this.coffeShop.settings.allow_pay_in_app === true) {
      this.disablePaymentButton = this.defaultPaymentMethod ? false : true;
    }
  }
  private setBookingButtonMessage(): void {
    const now = cloneDeep(new Date(this.nowMoment.setSeconds(0)));
    const bookedDate = new Date(this.bookedDate.setSeconds(0));
    if ((this.coffeShopService.bookingType && this.coffeShop.settings.allow_pay_in_app && this.totalCost > 1) ||
      (this.coffeShop.settings.allow_pay_in_app && this.totalCost > 0)) {
      this.buttonMessage = `Pay ${this.coffeShopService.setPrice(this.totalCost, false)}`;
      return;
    }
    if ((this.coffeShopService.bookingType && this.coffeShop.settings.allow_pay_in_app && this.totalCost < 1) ||
      (this.coffeShopService.bookingType && !this.coffeShop.settings.allow_pay_in_app)) {
      this.buttonMessage = `Join queue`;
      return;
    }

    if ((this.coffeShop.settings.allow_pay_in_app && this.totalCost === 0) ||
      (!this.coffeShop.settings.allow_pay_in_app && bookedDate.getTime() > now.getTime()) ||
      bookedDate.getTime() < now.getTime()) {
      this.buttonMessage = `Make advanced order`;
      return;
    }
  }
  private flatSelectedServiced(selectedServices: CoffeService[]): CoffeService[] {
    const doppings = [];
    selectedServices = selectedServices.map((service: CoffeService, index: number) => {
      service.group_id = index + 1;
      if (service.doppings && service.doppings.length) {
        service.doppings.forEach((dopping: CoffeService) => {
          dopping.group_id = service.group_id;
          dopping.special_instructions = '';
        });
        doppings.push(...service.doppings)
      }
      delete service.doppings;
      delete service.children;
      return service;
    });
    selectedServices.forEach((service: CoffeService) => {
      const doppingIndex = doppings.findIndex((dopping) => dopping.id === service.id);
      if (doppingIndex >= 0) { doppings.splice(doppingIndex, 1); }
    });
    const services = [...cloneDeep(selectedServices), ...cloneDeep(doppings)];
    return services;
  }
  private makeBooking(type: 1 | 2, append_time: boolean, requestBody?: any): Promise<any> {
    const services: CoffeService[] = this.flatSelectedServiced(this.selectedServices);
    const teamMember = this.coffeShopService.barbers && this.coffeShopService.barbers[this.selectedBarber] ? this.coffeShopService.barbers[this.selectedBarber] : this.coffeShopService.user;
    const body = requestBody ? requestBody : {
      type,
      last_booking_team_id: this.coffeShop.id,
      services: services,
      team: this.coffeShop.id,
      coupon_code: this.couponDetails ? this.couponDetails.code : null,
      coupon_amount: this.discount_amount,
      termsAccepted: true,
      user: localStorage.getItem('tuid'),
      teamMember
    }
    if (append_time) {
      body.bookingDate = this.selectedDate;
      body.bookingTime = this.selectedTime;
    }
    if (this.totalRedemptionApplied && this.totalRedemptionApplied > 0) { body.total_redemption_applied = this.totalRedemptionApplied; }
    body.serviceFee = this.coffeShopService.coffeShop.settings.allow_pay_in_app ? Number(this.coffeShopService.coffeShop.settings.platform_service_fee) : 0;
    return this.bookingService.makeBooking(body, this.navCtrl, false, false, 0, false, 'barmen');
  }
  changePaymentMethod() {

    if (this.loading) return;

    let modal = this.popoverCtrl.create(PaymentChangeMethodPopoverPage,
      {
        paymentMethods: this.paymentMethods,
        defaultPaymentMethod: this.defaultPaymentMethod,
      },
      {
        cssClass: 'change-payment-method-popover',
        enableBackdropDismiss: false
      });

    modal.present();

    modal.onDidDismiss((customer) => {
      if (customer) {
        this.customer = customer;
        this.setDefaultSource();
      }
    })
  }
  addPaymentMethod() {
    this.navCtrl.push(PaymentNewCardPage, { referrer: 'paymentPage' })
  }

  setDefaultSource() {
    return new Promise((resolve) => {
      if (this.paymentMethods) {
        for (let paymentMethod of this.paymentMethods.data) {
          if (paymentMethod.id === this.customer.invoice_settings.default_payment_method) {
            this.defaultPaymentMethod = paymentMethod;
            this.setPaymentButton();
            resolve(true);
          }
        }
      }
    });
  }
  subscribeToBookingServiceProviderEvents() {

    this.bookingService.unsubscribeFromEvents();

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:changeServiceTime', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 2));
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:forceAddToQueue', booking => {
      this.paymentEvent(booking);
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:joinAvailableSlot', booking => {
      this.paymentEvent(booking);
    });

    this.events.subscribe('validateStandardBookingEndsBeforeTeamOrMemberEndTime:forceAddToQueue', booking => {
      this.paymentEvent(booking);
    });

    this.events.subscribe('validateReplacedBookingFitsAvailableSlot:cancel', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 4));
    });

    this.events.subscribe('validateReplacedBookingFitsAvailableSlot:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 4));
    });


    this.events.subscribe('booking:forceAddToQueue', booking => {
      this.paymentEvent(booking);
    });

    this.events.subscribe('booking:changeServiceTime', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 2));
    });

    this.events.subscribe('booking:backToStart', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

    this.events.subscribe('booking:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

  }

  public paymentEvent(booking?: any): void {
    const now = cloneDeep(new Date(this.nowMoment.setSeconds(0)));
    const bookedDate = new Date(this.bookedDate.setSeconds(0));
    if (this.coffeShopService.bookingType && this.coffeShop.settings.allow_pay_in_app && this.totalCost > 1) {
      this.payInApp(1, false, booking, this.coffeShop.settings.allow_pay_in_app);
      return;
    }
    if (this.coffeShop.settings.allow_pay_in_app && this.totalCost > 1) {
      this.payInApp(2, true, booking, this.coffeShop.settings.allow_pay_in_app);
      return;
    }
    if ((this.coffeShopService.bookingType && this.coffeShop.settings.allow_pay_in_app && this.totalCost < 1) ||
      (this.coffeShopService.bookingType && !this.coffeShop.settings.allow_pay_in_app)) {
      this.joinQueue('join-queue');
      return;
    }

    if ((this.coffeShop.settings.allow_pay_in_app && this.totalCost === 0) ||
      (!this.coffeShop.settings.allow_pay_in_app && bookedDate.getTime() > now.getTime()) ||
      bookedDate.getTime() < now.getTime()) {
      this.payInApp(2, true, booking, this.coffeShop.settings.allow_pay_in_app);
      return;
    }
  }
  paymentIntent() {
    return this.stripeService.createPaymentIntent(this.totalCost, this.customer, this.coffeShopService.coffeShop.id);
  }
  payInApp(type: 1 | 2, append_time: boolean, booking: any = null, stripe: boolean) {
    if (this.loading) return;
    this.loading = true;
    // We pass the booking as it might have been updated in one of the validation events, if it's present it will override this.booking
    this.makeBooking(type, append_time, booking).then(booking => {
      // The booking was made successfully so we'll now attempt to capture the payment for the booking
      return new Promise(resolve => {
        if (!stripe) { return resolve([null, booking]); }
        this.paymentIntent().then(paymentIntent => {
          // The payment was captured successfully
          return resolve([paymentIntent, booking]);
        }).catch(error => {
          this.loading = false;
          // We weren't able to capture the payment
          if (error && error.payment_intent && error.payment_intent.id) {
            this.navCtrl.push(PaymentErrorPage, {
              paymentIntentId: error.payment_intent.id,
              shopType: 'coffe'
            })
          } else {
            this.errorHandler.handleError({ error })
          }
        });
      });
    }).then(([payment, booking]) => {
      // We'll now trigger app events from the booking provider and update the booking with the payment details
      return this.bookingService.bookingSuccessful(booking, payment, 'coffe');
    }).then((booking: any) => {
      this.publishBagde(booking);
    }).then(_ => {
      this._proccesNavCtrl();
    }).catch(error => {
      this.loading = false;
    });

  }
  joinQueue(bookingType: 'join-queue' | 'pay-at-location') {
    const paymentrequest = (type: 1 | 2, append_time: boolean) => {
      if (this.loading) return;
      this.loading = true;
      this.makeBooking(type, append_time).then(booking => {
        return this.bookingService.bookingSuccessful(booking, null, 'coffe');
      }).then((booking: any) => {
        this.publishBagde(booking);
      }).then(() => {
        this._proccesNavCtrl();
      }).catch(error => {
        this.loading = false;
      });
    }
    if (bookingType === 'pay-at-location') {
      let alert = this.alertCtrl.create({
        title: "Pay at coffeshop",
        subTitle: "Are you sure you want to pay at the coffeshop?",
        enableBackdropDismiss: false,
        buttons: [
          { text: 'Yes, Pay at coffeshop', handler: () => paymentrequest(this.coffeShopService.bookingType ? 1 : 2, this.coffeShopService.bookingType ? false : true) },
          { text: 'Cancel', role: 'cancel' },
        ]
      });
      alert.present();
    } else {
      paymentrequest(1, false);
    }

  }
  redeemLoyaltyPoints(loyalty) {
    if (!loyalty.can_redeem) return;
    this.showRedeemButton = false;
    let loyaltyPointsValueInCurrency = parseFloat(loyalty.points_value_in_currency);
    // If loyaltyPointsValueInCurrency >= to the service total cost then the booking is free and we'll use
    // the totalServiceCost in the calculation. Otherwise we'll use the total cost that also includes the service fee
    let totalCost = (loyaltyPointsValueInCurrency >= parseFloat(this.totalCost.toString()) ? parseFloat(this.totalCost.toString()) : parseFloat(this.totalCost.toString()));
    this.totalAfterRedemptionApplied = totalCost - loyaltyPointsValueInCurrency;
    this.totalRedemptionApplied = this.totalAfterRedemptionApplied > 0 ? loyalty.points_value_in_currency : this.totalCost;
    this.totalCost = parseFloat(this.totalAfterRedemptionApplied) > 0 ? this.totalAfterRedemptionApplied : 0;
    this.totalCost === 0 ? this.freeBooking = true : false;
    this.setBookingButtonMessage();
  }
  removeLoyaltyPoints(loyalty) {
    this.totalAfterRedemptionApplied = false;
    this.totalRedemptionApplied = 0;
    this.showRedeemButton = true;
    this.freeBooking = false;
    this.setTotalCost();
    this.setBookingButtonMessage();
  }


  private setTotalCost(): void {
    this.totalCost = 0;
    this.selectedServices.forEach((service: CoffeService) => this.totalCost += service.calculated_price);
    if (this.coffeShopService.coffeShop.settings.allow_pay_in_app && this.selectedServices.length > 0 && this.coffeShopService.coffeShop.settings.pass_platform_service_fee_to_customer && this.totalCost) {
      this.totalCost += Number(this.coffeShopService.coffeShop.settings.platform_service_fee);
    }
    console.log(this.totalCost );
    console.log(typeof(this.totalCost));
    
    
  }
  public goBack() {
    this.navCtrl.pop();
  }
  private publishBagde(booking): void {
    this.events.publish('booking:badge+', booking);
    if (booking.staff_member.user_id === parseInt(localStorage.getItem('tuid'))) {
      this.events.publish('myChair:badge', booking);
    }
  }
  private _proccesNavCtrl(): Promise<void> {
    this.coffeShopService.clearServiceData(true);
    this.coffeShopService.clearDates();
    return this.bookingService.gotoMyBookings(this.navCtrl);
  }

  public checkCouponCode() {
    if (typeof (this.couponCode) == "undefined" || this.couponCode.toString().trim() == "") {
      this.coffeShopService.presentToast("Enter Promo Code...");
      return;
    }

    this.coffeShopService.checkCouponcode(this.couponCode).subscribe(res => {
      if (res.is_vaild) {
        this.couponDetails = res.data;
        this.applyCoupon();
        this.coffeShopService.SuccessAlert();
        this.couponCode = null;
      } else {
        this.coffeShopService.presentToast(res.message);
      }
    }, err => {
      console.log("Erorr: ", err);
      this.coffeShopService.presentToast("Something went wrong, Please try again...");
    });
  }

  applyCoupon() {
    if (this.couponDetails) {
      this.discount_amount = 0;
      if (this.couponDetails.discount_type === 'fixed') {
        this.discount_amount = (this.couponDetails.discount_amount);
        this.totalCost =  Number(this.totalCost - this.discount_amount);
      } else {
        this.discount_amount = (this.couponDetails.discount_amount / 100) * this.totalCost;
        this.totalCost = this.totalCost - this.discount_amount;
      }
    }
  }

  removeCoupon() {
    this.totalCost = this.totalCost + Number(this.discount_amount);
    this.couponDetails = null;
  }

}



// WEBPACK FOOTER //
// ./src/pages/coffe-shop-payment/coffe-shop-payment.ts